import React from "react"
import Footer from "../organisation/footer/Footer";

import { Link } from "react-router-dom";

import { Button, Row, Col, Form, Card } from "react-bootstrap";

const Privacy = () => {

  return (
    <div>
      <div style={{ overflow: 'hidden', backgroundColor: '#141332', color: 'white', height: '100vh', padding: '3%' }}>
      <Row>
              <Col>
                <h3 style={{color: "white", marginleft: '5%', textAlign: 'left', fontWeight: '900'}}>Lingo Loco</h3>
              </Col>
              <Col style={{textAlign: 'right'}}>
              <Link to="/levels"><Button
                      sx={{ mt: 1, mr: 1 }}
                      style={{borderColor:'white', color: 'white', marginLeft: '20px'}}
                      variant="outlined"
                    >
                      Dashboard
              </Button></Link>
              <Link to="/languages"><Button
                      variant="contained"
                      sx={{ mt: 1, mr: 1 }}
                      style={{backgroundImage:'linear-gradient(to left, #ED4CDD, #428BC1)', color: 'white', marginLeft: '40px'}}
              >Get started</Button></Link>
              </Col>
            </Row>
        <h6 style={{paddingTop: '5%'}}>The plaform on this domain and the code base to create it have been made to only capture the users navigation such as level selection. this infomation is stored within the users local storage of their web browser. This allows the user autonomy to remove, keep and track their in browser experience. We take no liability should the API's we use manage to capture the users data independently from the platforms codebase.</h6>
      </div>
      <Footer/>  
    </div>
  );

};

export default Privacy;